/**
*
* BulletList
*
*/

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import Text, { textShape } from 'ui/Text';
import { colors } from 'ui/constants';

const StyledList = styled.ul`
  padding: 0px 0px 0px 10px;
  margin: 0;
  list-style: none;
  margin: 0;

  li {
    display: flex;
  }

  li::before {
    color: ${(props) => props.color};
    font-size: 14px;
  }
`;



function BulletList({ list, color, className }) {
  return (
    <StyledList className={className} color={color}>
      {list.map(({ key, text }) => (
        <li key={key}>
          <Text color={color} text={text} />
        </li>
      ))}
    </StyledList>
  );
}

BulletList.propTypes = {
  list: PropTypes.arrayOf(PropTypes.shape({
    key: PropTypes.string,
    text: textShape,
  })).isRequired,
  color: PropTypes.string,
  className: PropTypes.string,
};

BulletList.defaultProps = {
  color: colors.textBlack,
  className: null,
};

export default BulletList;
